import {
  UPDATE_MSTAR_FILTER,
  UPDATE_RANGE_FILTER,
  UPDATE_STYLE_BOX_FILTER,
  UPDATE_ASSET_FILTER,
  UPDATE_FUNDTYPE_FILTER,
  UPDATE_PRODUCT_FILTER,
  UPDATE_PRESET_CATEGORY,
  UPDATE_PLAN_NUMBER,
  FILTER_PLAN_HOLDINGS,
  SET_INITIAL_STATE,
  SHOW_ONLY_MY_HOLDINGS,
  RESET_FILTERS,
  RESET_HOLDINGS_CONTEXT,
  SHOW_ONLY_TIAA,
  SHOW_NULL_DATA,
  UPDATE_PARTICIPANT_HOLDINGS,
  UPDATE_SEARCHED_HOLDINGS,
  FETCH_PLAN_SUCCESS,
  FETCH_PLAN_FAILURE,
  FETCH_PLAN_REQUEST,
  FETCH_SCREENER_FAILURE
} from './action-types';
import { getScreenerPlanHoldings, getParticipantHoldings } from '../../../hooks/api';
import { internalApiClient } from '../../../services/screener-service';
import { tryParseJson } from '../../../utils/sharedHelpers';
import _get from 'lodash/get';

export const setInitialState = defaultView => {
  return {
    type: SET_INITIAL_STATE,
    defaultView
  };
};

export const showMyHoldings = () => {
  return {
    type: SHOW_ONLY_MY_HOLDINGS
  };
};

export const showOnlyTIAAProduct = () => {
  return {
    type: SHOW_ONLY_TIAA
  };
};

export const showFundsWithNullData = () => {
  return {
    type: SHOW_NULL_DATA
  };
};

export const resetFilters = channel => {
  return {
    type: RESET_FILTERS,
    channel
  };
};

export const updateMStarFilter = (array, val) => {
  return {
    type: UPDATE_MSTAR_FILTER,
    MStarArray: array,
    value: val
  };
};

const arrayFactory = (numTrue, numFalse) => {
  const array = [];
  let i = 1;
  while (i <= numTrue) {
    array.push(true);
    i++;
  }
  let j = 1;
  while (j <= numFalse) {
    array.push(false);
    j++;
  }
  return array;
};

export const mStarFilterUpdate = newValue => (dispatch, getState) => {
  const state = getState();
  const currentVal = state.filterReducer.filters.MStarValue;
  //if the new value and the old value are the same turn off
  let newFilterArray = [];
  if (newValue === currentVal) {
    newFilterArray = arrayFactory(0, 5);
    newValue = -1;
  } else {
    //otherwise turn on up to the new value
    const trueVal = newValue + 1;
    const falseVal = 5 - trueVal;
    newFilterArray = arrayFactory(trueVal, falseVal);
  }

  dispatch(updateMStarFilter(newFilterArray, newValue));
};

export const rangeFilterUpdate = (modelKey, index) => dispatch => {
  dispatch({
    type: UPDATE_RANGE_FILTER,
    modelKey,
    index
  });
};

export const updateAssetFilter = modelKey => dispatch => {
  dispatch({
    type: UPDATE_ASSET_FILTER,
    modelKey
  });
};

export const updateProductFilter =
  modelKey => dispatch => {
    dispatch({
      type: UPDATE_PRODUCT_FILTER,
      modelKey
    });
  };

export const updateFundTypeFilter = (
  modelKey,
  option
) => dispatch => {
  dispatch({
    type: UPDATE_FUNDTYPE_FILTER,
    modelKey,
    option
  });
};

export const styleBoxUpdate = (
  modelKey,
  xIndex,
  yIndex,
  checked
) => dispatch => {
  dispatch({
    type: UPDATE_STYLE_BOX_FILTER,
    modelKey,
    xIndex,
    yIndex
  });
};

export const updatePresetCategory = (sectionIndex, cardIndex, channel) => dispatch => {
  dispatch({
    type: UPDATE_PRESET_CATEGORY,
    sectionIndex,
    cardIndex,
    channel
  });
};

export const updatePlanNumber = (planNumber, subPlan) => dispatch => {
  dispatch({
    type: UPDATE_PLAN_NUMBER,
    planNumber,
    subPlan
  });
};

export const filterPlanHoldings = (payload, isPlanDataLoaded) => dispatch => {
  dispatch({
    type: FILTER_PLAN_HOLDINGS,
    payload,
    isPlanDataLoaded
  });
};

export const restoreParticipantHoldings = (payload, isPlanDataLoaded) => dispatch => {
  dispatch({ type: RESET_HOLDINGS_CONTEXT });
  dispatch({
    type: FILTER_PLAN_HOLDINGS,
    payload,
    isPlanDataLoaded
  });
};

export const fetchPlanFailure = error => {
  return {
    type: FETCH_PLAN_FAILURE,
    payload: error
  };
};

export const fetchPlanSuccess = () => {
  return {
    type: FETCH_PLAN_SUCCESS
  };
};

export const fetchPlanRequest = () => {
  return {
    type: FETCH_PLAN_REQUEST
  };
};

/*Used for Searched Plan */
export const updatePlanHoldings = (planNumber, subPlan, channel, yyy) => {
  return dispatch => {
    dispatch({
      type: UPDATE_PLAN_NUMBER,
      planNumber,
      subPlan,
      channel
    });
    dispatch(fetchPlanRequest());
    let params = [{ planNumber, includeDisclosures: true }];

    if (subPlan) {
      params = [{ planNumber, includeDisclosures: true, subPlan }];
    }

    internalApiClient(yyy, channel).then(service => {
      const inputs = {
        client: service,
        params
      };
      Promise.all(getScreenerPlanHoldings(inputs)).then(response => {
        if (response[0]?.holdings?.length && response[0]?.productTypes?.length) {
          dispatch(fetchPlanSuccess());
          dispatch({
            type: UPDATE_SEARCHED_HOLDINGS,
            payload: response
          });
          dispatch(filterPlanHoldings(response, true));
        } else {
          const errorMsg = 'Plan number is invalid. Please provide a valid plan number to view investments.';
          dispatch(fetchPlanFailure(errorMsg));
          dispatch({
            type: FETCH_SCREENER_FAILURE,
            payload: errorMsg
          });
        }
      })
        .catch(error => {
          const errorMsg = error.message;
          dispatch(fetchPlanFailure(errorMsg));
        });
    })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchPlanFailure(errorMsg));
      });
  };
};

/*Used for Microsites */
export const updateDynamicMicrosite = (Plans, channel, yyy) => {
  return dispatch => {
    dispatch(fetchPlanRequest());
    const planHoldingParams = [];

    if (Plans && Plans.length) {
      Plans.forEach(plan => {
        planHoldingParams.push({ planNumber: plan.PlanId, subPlan: plan.SubPlanId, includeDisclosures: true });
      });
    }

    internalApiClient(yyy, channel).then(service => {
      const inputs = {
        client: service,
        params: planHoldingParams
      };
      Promise.all(getScreenerPlanHoldings(inputs)).then(response => {
        dispatch(fetchPlanSuccess());
        dispatch({
          type: UPDATE_PARTICIPANT_HOLDINGS,
          payload: response,
          userHoldings: []
        });
        dispatch(filterPlanHoldings(response, true));
      })
        .catch(error => {
          const errorMsg = error.message;
          dispatch(fetchPlanFailure(errorMsg));
        });
    })
      .catch(error => {
        const errorMsg = error.message;
        dispatch(fetchPlanFailure(errorMsg));
      });
  };
};

/*Used for MyTiaa */
export const updateParticipantHolding = (channel, yyy) => {
  return async (dispatch, getState) => {
    dispatch(fetchPlanRequest());
    try {
      const participantHoldings = await getParticipantHoldings({ channel });
      const resultRaw = participantHoldings?.data?.slice(
        participantHoldings.data.indexOf('_information(') + 13,
        participantHoldings.data.lastIndexOf(')')
      );

      //To mock participant holdings return:
      //set resultParsed to mockParticipantHoldings  const resultParsed = mockParticipantHoldings;
      //set getParticipantHoldings to simply return Promise.resolve([]);
      const resultParsed = tryParseJson(resultRaw) || {};
      const userHoldingsRaw = _get(resultParsed, 'apps[0].data.plans', []);
      const userHoldings = trimSubPlanNumbers(userHoldingsRaw);

      const planHoldingParams = userHoldings?.length
        ? userHoldings
          .map(({ planNumber, subPlanNumber } = {}) => {
            return planNumber ? { planNumber, subPlan: subPlanNumber, includeDisclosures: true } : false;
          })
          .filter(Boolean)
        : [];

      const state = getState();
      const searchedPlanNumber = state.filterReducer.inputs.searchedPlanNumber;

      //If there are user plans, make screener call, if the user has no plans, dispatch an error to display in plan search hover.
      if (userHoldingsRaw.length) {
        const service = await internalApiClient(yyy, channel);
        const inputs = {
          client: service,
          params: planHoldingParams
        };
        const response = await Promise.all(getScreenerPlanHoldings(inputs));
        dispatch(fetchPlanSuccess());
        dispatch({
          type: UPDATE_PARTICIPANT_HOLDINGS,
          payload: response,
          userHoldings,
          searchedPlanNumber
        });
        dispatch(filterPlanHoldings(response, true));
      } else {
        dispatch(fetchPlanFailure('You do not have a retirement plan with TIAA. Please provide a valid plan number to view investments.'));
        dispatch({
          type: FETCH_SCREENER_FAILURE,
          payload: 'Plan holding is empty'
        });
      }
    } catch (error) {
      const errorMsg = error.message;
      dispatch(fetchPlanFailure(errorMsg));
    }
  };
};

function trimSubPlanNumbers(userHoldingsRaw) {
  const userHoldings = userHoldingsRaw.map(plan => {
    return { ...plan, subPlanNumber: plan.subPlanNumber.substring(0, 3) };
  });
  return userHoldings;
}
